import type {FaceShape,Morphs} from '../../shared/atelier';

/** A new authored recipe, not a reinterpretation of saved slider values.
 * Keeping this separate from DEFAULT_MORPHS preserves existing characters. */
export const MANUSCRIPT_MORPHS:Readonly<Morphs>=Object.freeze({head:.82,belly:.92,legs:1.12,arms:1.06,tail:1,ears:1});

/** Keep the fitted skull/nose/mouth and species colours. Only the expressive
 * proportions change; the ordinary sliders and animated emotion still apply. */
export function manuscriptFace(base:FaceShape):FaceShape{
  return {...base,irisColor:[...base.irisColor],noseColor:[...base.noseColor],
    eyeSize:Math.max(.18,base.eyeSize*.84),eyeAspect:Math.max(.38,base.eyeAspect*.78),
    irisSize:Math.max(.4,Math.min(.7,base.irisSize*.86)),
    lidHeavy:Math.max(.24,base.lidHeavy),bags:Math.max(.28,base.bags),
    browThickness:Math.min(base.browThickness,.022),mouthSmile:Math.min(base.mouthSmile,.04)};
}
